import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

const CircleCheck = (props: SvgIconProps) => {
  return (
    <SvgIcon {...props}>
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width='24'
        height='24'
        viewBox='0 0 24 24'
        fill='none'
        stroke='currentColor'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
        className='lucide lucide-circle-check-big-icon lucide-circle-check-big'
      >
        <path d='M21.801 10A10 10 0 1 1 17 3.335' />
        <path d='m9 11 3 3L22 4' />
      </svg>
    </SvgIcon>
  );
};

export default CircleCheck;
